import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { Subsection } from 'src/app/models/subsection';

@Injectable({
  providedIn: 'root',
})
export class SubsectionsService {
  createSubsection(subsection: Subsection & { template_section_id: number }): Observable<Subsection> {
    return this.apiService.post<Subsection & { template_section_id: number }>(
      `/dashboard/subsection/${subsection.template_section_id}`,
      subsection
    );
  }

  updateSubsection(subsection: Subsection & { template_section_id: number }): Observable<Subsection> {
    return this.apiService.put<Subsection & { template_section_id: number }>(
      `/dashboard/subsection/${subsection.template_section_id}/${subsection.id}`,
      subsection
    );
  }

  deleteSubsection(subsection: Subsection): Observable<Subsection> {
    return this.apiService.delete<Subsection>(`/dashboard/subsection/${subsection.id}`);
  }

  constructor(private apiService: ApiService) {}
}
